import { getDefaultClient } from '@dynamic-labs-sdk/client';
import {
  MethodNotImplementedError,
  getWalletProviderFromWalletAccount,
} from '@dynamic-labs-sdk/client/core';

import type { BitcoinWalletAccount } from '../BitcoinWalletAccount.types';
import type {
  BitcoinSendTransactionResponse,
  BitcoinTransaction,
} from '../BitcoinWalletProvider.types';
import { NotBitcoinProviderError } from '../errors/NotBitcoinProviderError';
import { isBitcoinWalletProvider } from '../isBitcoinWalletProvider';

type SendBitcoinParams = {
  transaction: BitcoinTransaction;
  walletAccount: BitcoinWalletAccount;
};

/**
 * Sends a Bitcoin transaction
 * @param params.transaction - The transaction to send
 * @param params.walletAccount - The wallet account to send the transaction from
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An object containing the transaction id
 * @throws {MethodNotImplementedError} If the wallet provider does not implement the sendBitcoin method
 * @throws {NotBitcoinProviderError} If the wallet account is not a valid BitcoinWalletAccount
 */
export const sendBitcoin = async (
  { walletAccount, transaction }: SendBitcoinParams,
  client = getDefaultClient()
): Promise<BitcoinSendTransactionResponse> => {
  const provider = getWalletProviderFromWalletAccount(
    {
      walletAccount,
    },
    client
  );

  if (!isBitcoinWalletProvider(provider)) {
    throw new NotBitcoinProviderError({ providerKey: provider.key });
  }

  if (!provider.sendBitcoin) {
    throw new MethodNotImplementedError('sendBitcoin');
  }

  return provider.sendBitcoin({ transaction, walletAccount });
};
